import { rem } from 'polished'
import React, { useContext, useReducer } from 'react'
import styled from 'styled-components'
import { DesktopLayoutSizes } from 'tripPlanner/components/ItemCard/Common/utils'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'
import AboveCardCloseButton from '../Common/AboveCardCloseButton'
import useClickOutsideBox from '../../hooks/useClickOutsideBox'
import { StyledModalBody } from 'components/Luxkit/Modal/ModalBody'
import { StyledModalFooter } from 'components/Luxkit/Modal/ModalFooter'
import { StyledModalHeader } from 'components/Luxkit/Modal/ModalHeader'
import { MODAL_HEADER_GRID_AREA, MODAL_BODY_GRID_AREA, MODAL_FOOTER_GRID_AREA } from 'components/Luxkit/Modal/ModalSheet'
import { LuxkitModalBehaviourStateContext, LuxkitModalBehaviourDispatchContext } from 'components/Luxkit/Modal/context/LuxkitModalBehaviourContexts'
import { luxkitModalBehaviourStateReducer, MODAL_BEHAVIOUR_INITIAL_STATE } from 'components/Luxkit/Modal/context/LuxkitModalBehaviourState'

const DesktopContainer = styled.div`
  position: absolute;
  z-index: 5;
  padding: ${rem(16)};
  bottom: 0;
  width: 100%;
  pointer-events: none;
  display: flex;
  justify-content: center;

  ${DesktopLayoutSizes} {
    padding: 24px;
  }
`

const DesktopTile = styled.div`
  position: relative;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${props => props.theme.shadow.bottom.medium};
  width: ${rem(700)};
  max-width: calc(100% - ${rem(32)});
  max-height: ${rem(450)};
  pointer-events: auto;

  display: grid;
  grid-template-areas:
    '${MODAL_HEADER_GRID_AREA}'
    '${MODAL_BODY_GRID_AREA}'
    '${MODAL_FOOTER_GRID_AREA}';
  grid-template-rows:
    [first]
    min-content
    1fr
    min-content
    [last];
  grid-template-columns: [first] 1fr [last];

  > ${StyledModalHeader} {
    grid-area: ${MODAL_HEADER_GRID_AREA};
  }

  > ${StyledModalBody} {
    grid-area: ${MODAL_BODY_GRID_AREA};
  }

  > ${StyledModalFooter} {
    grid-area: ${MODAL_FOOTER_GRID_AREA};
  }
`

interface Props {
  cardRef: React.RefObject<HTMLDivElement>
}

function DesktopOfferMapCard({ cardRef, children }: React.PropsWithChildren<Props>) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  useClickOutsideBox(cardRef, onDeselectMapItem, { excludeModalClicks: true })

  const [state, dispatch] = useReducer(luxkitModalBehaviourStateReducer, MODAL_BEHAVIOUR_INITIAL_STATE)

  return (
    <DesktopContainer>
      <DesktopTile ref={cardRef}>
        <AboveCardCloseButton onClick={onDeselectMapItem} />
        <LuxkitModalBehaviourStateContext.Provider value={state}>
          <LuxkitModalBehaviourDispatchContext.Provider value={dispatch}>
            {children}
          </LuxkitModalBehaviourDispatchContext.Provider>
        </LuxkitModalBehaviourStateContext.Provider>
      </DesktopTile>
    </DesktopContainer>
  )
}

export default DesktopOfferMapCard
